goog.provide("shadow.js.shim.module$$mui$material$Drawer$default");
shadow.js.shim.module$$mui$material$Drawer$default = shadow.js.shim.module$$mui$material$Drawer.default;
